import { FendtVarioDocHttp } from './http/FendtVarioDocHttp';

/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 18.02.15.
 */

angular
  .module('farmnet.partner.fendt', ['farmnet.partner.externalAccounts'])
  .service('fendtConfig', [
    'farmnetConfig',
    function(farmnetConfig) {
      'use strict';

      this.templateBasePath =
        farmnetConfig.modulesBasePath + '/farmnet/partner.fendt/ui';
      this.restPath = farmnetConfig.restBasePath + '/partner/fendt';
      this.restVarioDocPath = this.restPath + '/varioDoc';
    }
  ])
  .service('fendtVarioDocHttp', FendtVarioDocHttp);
